"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var sortBy = require('lodash/sortBy');

var _require = require('../../products/constants'),
    LINER_SAMPLES = _require.LINER_SAMPLES;

var sortByDesignation = require('./sortByDesignation');

var filterProofingFunction_reprint = function filterProofingFunction_reprint(j) {
  return !j.is_test_print && j.status !== 'canceled';
};

var filterProofingFunction = function filterProofingFunction(j) {
  return !j.is_reprint && !j.is_test_print && j.status !== 'canceled';
};

module.exports = function collateJobs(order, existingJobs, defaultJobs) {
  // processing the jobs this way lists the shipments/printJobs in such a way that
  // if there is an expected job that has not been instantiated yet,
  // it will be listed as 'none'. Otherwise, it will list any jobs that
  // have filled that expected slot.
  var sortedJobs = {};
  [].concat(_toConsumableArray(existingJobs), _toConsumableArray(defaultJobs)).forEach(function (job) {
    var designation = job.status === 'canceled' ? 'canceled' : job.designation;

    if (!sortedJobs[designation]) {
      sortedJobs[designation] = [];
    }

    sortedJobs[designation].push(job);
  });
  var filteredJobsToDisplay = [];
  var customColorChartJobs = [];
  var linerSamplesJobs = [];
  var testPrintJobs = [];
  var canceledJobs = [];
  var reprintJobs = [];
  var filterProofing = order.has_reprints ? filterProofingFunction_reprint : filterProofingFunction;
  var orderOnlyHasLinerSamples = order.products.every(function (product) {
    return product.product_type === LINER_SAMPLES;
  });
  Object.keys(sortedJobs).forEach(function (designation) {
    sortedJobs[designation].forEach(function (job) {
      if (job.status === 'canceled') {
        canceledJobs.push(job);
      } else if (job.is_test_print) {
        testPrintJobs.push(job);
      } else if (!order.has_reprints && job.is_reprint) {
        reprintJobs.push(job);
      } else if (job.designation.match(/custom_color/)) {
        customColorChartJobs.push(job);
      } else if (job.designation.match(/liner_samples/) && !orderOnlyHasLinerSamples) {
        linerSamplesJobs.push(job);
      } else if (job.status === 'proofing' && sortedJobs[designation].filter(filterProofing).length === 1) {
        filteredJobsToDisplay.push(job);
      } else if (job.status !== 'proofing') {
        filteredJobsToDisplay.push(job);
      }
    });
  });
  var sortedJobsToDisplay = sortBy(filteredJobsToDisplay, [sortByDesignation]);
  sortedJobsToDisplay.canceled = canceledJobs;
  sortedJobsToDisplay.testPrints = testPrintJobs;
  sortedJobsToDisplay.reprints = reprintJobs;
  sortedJobsToDisplay.customColorCharts = customColorChartJobs;
  sortedJobsToDisplay.linerSamples = linerSamplesJobs; // returns an Array, but with extra properties, just like .match() does.

  return sortedJobsToDisplay;
};